import { EmptyState, SkeletonLoader, YStack } from '@shinetools/lumen-react'
import { useTranslation } from 'react-i18next'
import { Navigate, useParams } from 'react-router'

import { useResolveZervantDocument } from '@features/zervantDocuments/hooks/useResolveZervantDocument'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getOrganizationViewUrl } from '../../../../utils/routing/getOrganizationViewUrl'
import { getZervantDocumentTargetRoute } from './utils/getZervantDocumentTargetRoute'

interface ZervantDocumentRedirectUrlParams {
  billyId: string
}

type ZervantDocumentRedirectUrlParamsGeneric = Pick<
  ZervantDocumentRedirectUrlParams,
  keyof ZervantDocumentRedirectUrlParams
>

export const ZervantDocumentRedirect = () => {
  const { t } = useTranslation()
  const { billyId } = useParams<ZervantDocumentRedirectUrlParamsGeneric>()
  const { organization } = useUserOrganization()
  const { document, isError, isNotFound } = useResolveZervantDocument(billyId)

  if (isNotFound || isError) {
    return (
      <YStack padding={24}>
        <EmptyState
          description={t('zervant_document_redirect.not_found.description')}
          title={t('zervant_document_redirect.not_found.title')}
          type="error"
        />
      </YStack>
    )
  }

  if (!document || !organization) {
    return (
      <YStack gap={8} padding={24}>
        <SkeletonLoader height={32} shape="text" width={240} />
        <SkeletonLoader height={16} shape="text" width={360} />
      </YStack>
    )
  }

  // `replace` makes the Ember bridge use `replaceWith`, so Back skips this page.
  return <Navigate replace to={getOrganizationViewUrl(organization.url, getZervantDocumentTargetRoute(document))} />
}
